<template>
  <div>
    <a-modal
      title="Contact Info"
      :visible="bookTypeNum !== null"
      :maskClosable="false"
      @cancel="handleBookTypeModalCancel"
    >
      <a-form layout='horizontal' :form="agentForm" class="contactInfoBox">
        <a-form-item
          label="Booking Type"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select>
            <a-select-option value="0">
              Agent
            </a-select-option>
            <a-select-option value="1">
              Direct Customer
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="Gender"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder=""
          >
            <a-select-option value="M">Male</a-select-option>
            <a-select-option value="F">Female</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="Last Name"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input/>
        </a-form-item>
        <a-form-item
          label="First Name"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input/>
        </a-form-item>
        <a-form-item
          label="Telephone"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          class="telephoneCode"
        >
          <div class="flex-1">
            <PhonenumberInput :initData="{ countryCode: 'US', countryCallingCode: '1', isValid: false, phoneNumber: '' }"/>
          </div>
          <div class="phoneExtensionCode">
            <a-input
              placeholder="Ext."
              />
          </div>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-popconfirm
          title="Are you sure?"
          @confirm="handleBookTypeModalConfirm"
          ok-text="Yes" 
          cancel-text="No"
        >
          <a-button type="primary">Confirm</a-button>
        </a-popconfirm>
      </template>
    </a-modal>
  </div>
</template>

<script>
import PhonenumberInput from '@/components/input/phonenumber/PhoneNumberInput'

export default {
  name: 'ContactBookingType',
  components: {
    PhonenumberInput
  },
  props: {
    bookTypeNum: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      phoneNumberData: null,
      showContactModal:false,
      agentForm: this.$form.createForm(this)
    }
  },
  mounted () {
  },
  methods: {
    handleBookTypeModalCancel () {
      this.$emit('cancel')
    },
    handleBookTypeModalConfirm () {
       this.$emit('confirm')
    }
  }
}
</script>
<style lang="less" scoped>
.telephoneCode ::v-deep .ant-form-item-children {
	display: flex;
	line-height: normal;
}
.phoneExtensionCode {
	width: 70px;
	margin-left: -5px;
}
.phoneExtensionCode input {
	line-height: 40px;
	height: 40px;
	display: block;
	border-bottom-left-radius: 0;
	border-top-left-radius: 0;
}
.telephoneCode ::v-deep .ant-form-item-control {
	line-height: normal;
}
.contactInfoBox ::v-deep .input-tel__label {
  line-height: 18px;
}
</style>